export enum NotificationCheckMode {
  ACTION = 'action',
  VIEW = 'view',
}
